import { render, staticRenderFns } from "./ReviewElement.vue?vue&type=template&id=8e61c3c8&scoped=true&"
import script from "./ReviewElement.vue?vue&type=script&lang=js&"
export * from "./ReviewElement.vue?vue&type=script&lang=js&"
import style0 from "./ReviewElement.vue?vue&type=style&index=0&id=8e61c3c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e61c3c8",
  null
  
)

export default component.exports